import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../components/LanguajeContext";
import translations from "../utils/paymentServiceOnvo.translate";
export default function PaymentServiceOnvo() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sdkReady, setSdkReady] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const URL = process.env.REACT_APP_SERVER_URL;
  const { language } = useLanguage();
  const t = translations[language];
  const booking = location.state?.booking;
  //const participants= location.state?.participants

  useEffect(() => {
    if (!booking) navigate("/servicios");
  }, [booking, navigate]);


  useEffect(() => {
    const interval = setInterval(() => {
      if (window.onvo && typeof window.onvo.pay === "function") {
        setSdkReady(true);
        clearInterval(interval);
        console.log(t.sdkLoaded);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [t.sdkLoaded]);


  useEffect(() => {
    if (sdkReady && booking) {
      initializePayment();
    }
  }, [sdkReady, booking]);

  const initializePayment = async () => {
    setLoading(true);
    setError("");

    try {
    
      const response = await fetch(`${URL}/api/payment/create-payment-intention`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          bookingId: booking.id_booking,
          amount: Math.round(booking.total_amount_colon * 100),
          currency: "CRC",
          operatorId: booking.id_operator,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || t.creatingIntentError);
      }

      const { paymentIntentId } = data;
      if (!paymentIntentId) {
        throw new Error(t.missingData);
      }

    
      const onvoInstance = window.onvo.pay({
        publicKey: process.env.REACT_APP_ONVO_PUBLIC_KEY,
        paymentType: "one_time",
        paymentIntentId,

        onSuccess: async (result) => {
          try {
            await fetch(`${URL}/api/payment/confirm-payment-reservation/ `, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                paymentIntentId: result.id,
                bookingId: booking.id_booking,
                status: result.status,
              }),
            });

            alert(t.successPayment);
            navigate("/payment-client/success");
          } catch (err) {
            console.error("⚠️ Error confirmando pago:", err);
            alert(t.confirmError);
          }
        },

        onError: (error) => {
          console.error("❌ Error en pago:", error);
          setError(t.paymentError);
        },
      });

      onvoInstance.render("#onvo-payment-container");
    } catch (err) {
      console.error("🚨 Error iniciando pago:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50">
      <button
        onClick={() => navigate(-1)}
        className="self-start mb-4 flex items-center text-blue-600 hover:text-blue-800"
      >
        <ArrowLeft size={20} className="mr-2" />
        {t.back}
      </button>

      <motion.h1
        className="text-3xl font-bold mb-2 text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        {t.completePayment}
      </motion.h1>

      <motion.p
        className="text-lg text-gray-600 mb-6 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1 }}
      >
        {t.service}: <strong>{booking?.service_name}</strong> — $
        {booking?.total_amount_usd}
      </motion.p>

      {error && (
        <div className="bg-red-100 text-red-700 border border-red-300 px-4 py-2 rounded mb-4 max-w-md w-full">
          {error}
        </div>
      )}

      <div className="w-full max-w-md">
        {loading && (
          <div className="flex justify-center items-center py-8">
            <Loader2 className="animate-spin mr-2" size={24} />
            <span>{t.loadingForm}</span>
          </div>
        )}

        <div
          id="onvo-payment-container"
          className={`transition-all ${sdkReady ? "opacity-100" : "opacity-0"}`}
        ></div>
      </div>
    </div>
  );
}
//